import { render, staticRenderFns } from "./VariantSelectedPreview.vue?vue&type=template&id=03179bb2"
import script from "./VariantSelectedPreview.vue?vue&type=script&lang=ts"
export * from "./VariantSelectedPreview.vue?vue&type=script&lang=ts"
import style0 from "./VariantSelectedPreview.vue?vue&type=style&index=0&id=03179bb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports